var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNubeGrandeDerechaAzulBirdybacker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 569,
    height: 162,
    viewBox: "0 0 569 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M674 161.986H182.497C165.534 161.986 151.788 148.235 151.788 131.267C151.788 114.298 165.534 100.547 182.497 100.547H291.424C299.617 100.547 306.27 93.9053 306.27 85.696C306.27 77.5004 299.63 70.8449 291.424 70.8449H35.4107C15.8496 70.8449 0 54.9763 0 35.4225C0 15.8549 15.8634 0 35.4107 0H674V162V161.986Z",
    fill: "#B5EAD7",
    fillOpacity: 0.31
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNubeGrandeDerechaAzulBirdybacker);
export default __webpack_public_path__ + "static/media/nube-grande-derecha-azul-birdybacker.db0dd391bc2198de87221319c57c6c5b.svg";
export { ForwardRef as ReactComponent };